import { useCallback } from "react";
import type { ShockEvent } from "../../../api";
import { store } from "../../../store";
import { useFetchAction, type UseFetchActionReturn } from "../utils";

export const useFetchShockEvent = (
    shockEventId?: string | null,
): UseFetchActionReturn<ShockEvent | undefined> => {
    const fetchShockEvent: () => Promise<ShockEvent | undefined> = useCallback(() => {
        if (shockEventId) {
            return store.shockEventsApi.shockEventsReadShockEvent({ shockEventId });
        } else {
            return Promise.resolve(undefined);
        }
    }, [shockEventId]);
    return useFetchAction(fetchShockEvent);
};
